"use client"

import { AppProgressBar } from "next-nprogress-bar"
import { usePathname } from "next/navigation"
import NProgress from "nprogress"
import "nprogress/nprogress.css"
import { useEffect } from "react"

// Configure NProgress to hide spinner
NProgress.configure({ showSpinner: false })

const Providers = ({ children }: { children: React.ReactNode }) => {
  const pathname = usePathname()

  useEffect(() => {
    NProgress.start()

    const timer = setTimeout(() => {
      NProgress.done()
    }, 500)

    return () => {
      clearTimeout(timer)
      NProgress.done()
    }
  }, [pathname])

  return (
    <>
      <AppProgressBar
        height="2px"
        color="#1E4259"
        options={{
          showSpinner: false,
        }}
        delay={500}
      />
      {children}
    </>
  )
}

export default Providers
